const ROLE_COMPANY_ADMIN = 1;

export const isSuperAdmin = (user) => Boolean(user) && Array.isArray(user.switchable) && user.switchable.includes(0);

// 2段階認証設定画面を使えるのは企業管理者（と全体管理者）のみ
export const canManageMfa = (user) => Boolean(user) && (user.role === ROLE_COMPANY_ADMIN || isSuperAdmin(user));
